/**
 * Builds "What's in the kit" swatches from the product description + media.
 * Expects description lines like: "Fabric name 28104 21 — 1/2 yd"
 */
(function () {
  const roots = document.querySelectorAll('[data-kit-contents]');
  if (!roots.length) return;

  const lineRe = /^(.+?)\s+[—–-]\s+([\d.\/]+\s*(?:yds?|yards?|each|ea|fq|pcs?)\b.*)$/i;

  function mediaKey(item) {
    return String((item && (item.src || item.url)) || item || '').toLowerCase();
  }

  function isPatternOrCover(item) {
    return /\/p-\d+|\/img_|_lg-|cover|hero|component\.jpg|back\.jpg/i.test(mediaKey(item));
  }

  function findByStyle(itemList, name, used) {
    const candidates = [];
    const style = name.match(/(\d{4,5})\s+(\d{2,3}[A-Za-z]?)\b/);
    if (style) {
      const a = style[1];
      const b = style[2];
      candidates.push(a + '_' + b, a + '-' + b, a + '/' + b, a + b, 'rs_' + a + '_' + b, 'rs' + a + '-' + b);
    }
    const rs = name.match(/\b(RS[\d._-]+[A-Za-z]?)\b/i);
    if (rs) {
      candidates.push(rs[1], rs[1].replace(/-/g, '_'), rs[1].replace(/_/g, '-'));
    }
    const fb = name.match(/\b(FB[-\s]?\d{2,4})\b/i);
    if (fb) {
      candidates.push(fb[1].replace(/\s+/g, '-'), fb[1].replace(/[\s-]/g, ''));
    }

    for (const needle of candidates) {
      const n = String(needle).toLowerCase();
      for (const item of itemList) {
        const key = mediaKey(item);
        if (used.has(key)) continue;
        if (key.indexOf(n) > -1) return item;
      }
    }
    return null;
  }

  function nextFabricImage(itemList, used) {
    let preferred = null;
    for (const item of itemList) {
      const key = mediaKey(item);
      if (used.has(key) || isPatternOrCover(item)) continue;
      if (/\/fb-\d+|\/\d{4,5}[_-]\d{2}|\/rs[_-]?\d+/i.test(key)) return item;
      if (!preferred) preferred = item;
    }
    return preferred;
  }

  function cleanName(name) {
    return name
      .replace(/\s+\d{4,5}\s+\d{2,3}[A-Za-z]?\s+\w+$/i, '')
      .replace(/\s+\b(RS[\d._-]+[A-Za-z]?)\b\s+\w+$/i, '')
      .trim();
  }

  roots.forEach((root) => {
    const mediaEl = root.querySelector('[data-kit-media]');
    const descEl = document.querySelector(root.dataset.descriptionSelector || '.product__description');
    const list = root.querySelector('[data-kit-list]');
    const countEl = root.querySelector('[data-kit-count]');
    if (!mediaEl || !descEl || !list) return;

    let media = [];
    try {
      media = JSON.parse(mediaEl.textContent || '[]');
    } catch (e) {
      media = [];
    }

    const rows = [];
    const scratch = document.createElement('div');
    descEl.querySelectorAll('p, li, div').forEach((el) => {
      if (el.querySelector('p, li, div')) return;
      el.innerHTML.split(/<br\s*\/?>/i).forEach((chunk) => {
        scratch.innerHTML = chunk;
        const m = scratch.textContent.replace(/\s+/g, ' ').trim().match(lineRe);
        if (!m) return;
        const name = m[1].trim();
        const qty = m[2].trim();
        if (/pattern/i.test(name) && /each/i.test(qty)) return;
        rows.push({ name, qty });
      });
    });

    if (rows.length < 2) return;

    const used = new Set();
    const assignments = rows.map((r) => {
      const hit = findByStyle(media, r.name, used);
      if (hit) used.add(mediaKey(hit));
      return { row: r, media: hit };
    });
    assignments.forEach((entry) => {
      if (entry.media) return;
      const fallback = nextFabricImage(media, used);
      if (fallback) {
        used.add(mediaKey(fallback));
        entry.media = fallback;
      }
    });

    assignments.forEach((entry) => {
      const li = document.createElement('li');
      li.className = 'kit-contents__item';
      const sw = entry.media ? entry.media.url || entry.media.src || '' : '';
      li.innerHTML =
        '<i class="kit-contents__swatch" aria-hidden="true"></i>' +
        '<span class="kit-contents__name"></span>' +
        '<span class="kit-contents__qty"></span>';
      if (sw) li.children[0].style.backgroundImage = 'url(' + sw + ')';
      li.children[1].textContent = cleanName(entry.row.name);
      li.children[2].textContent = entry.row.qty;
      list.appendChild(li);
    });

    if (countEl) {
      countEl.textContent = rows.length + ' pieces';
    }
    root.hidden = false;
  });
})();
